import ArrowBackRounded from "@mui/icons-material/ArrowBackRounded";
import MoreHorizRounded from "@mui/icons-material/MoreHorizRounded";
import type { FC, MouseEvent } from "react";
import "./GamePageHeader.css";

export interface GamePageHeaderProps {
	title: string;
	titleId?: string;
	backLabel: string;
	moreLabel: string;
	onBack: () => void;
	onMore: (event: MouseEvent<HTMLButtonElement>) => void;
	moreExpanded?: boolean;
	moreControls?: string;
	status?: string;
}

export const GamePageHeader: FC<GamePageHeaderProps> = ({
	title,
	titleId,
	backLabel,
	moreLabel,
	onBack,
	onMore,
	moreExpanded = false,
	moreControls,
	status,
}) => (
	<header className="game-page-header">
		<button
			type="button"
			className="game-page-header__action"
			aria-label={backLabel}
			onClick={onBack}
		>
			<ArrowBackRounded />
		</button>
		<div className="game-page-header__center">
			<h1 id={titleId}>{title}</h1>
			<div className="game-page-header__ornament" aria-hidden="true">
				<span />
			</div>
		</div>
		<div className="game-page-header__end">
			{status ? (
				<span className="game-page-header__status" role="status">
					{status}
				</span>
			) : null}
			<button
				type="button"
				className="game-page-header__action"
				aria-label={moreLabel}
				aria-haspopup="menu"
				aria-expanded={moreExpanded}
				aria-controls={moreExpanded ? moreControls : undefined}
				onClick={onMore}
			>
				<MoreHorizRounded />
			</button>
		</div>
	</header>
);
